import { Eye, Download, Trash2 } from "lucide-react";

/** Capsule fichier partagée (badge format coloré + nom + Voir / Télécharger) — étapes, SUIVI, pièces de dossier. */
export const FILE_TYPE_META = {
  pdf:  { color: "#DC2626", bg: "rgba(220,38,38,0.12)", label: "PDF" },
  doc:  { color: "#2563EB", bg: "rgba(37,99,235,0.12)", label: "DOC" },
  docx: { color: "#2563EB", bg: "rgba(37,99,235,0.12)", label: "DOCX" },
  xls:  { color: "#16A34A", bg: "rgba(22,163,74,0.12)", label: "XLS" },
  xlsx: { color: "#16A34A", bg: "rgba(22,163,74,0.12)", label: "XLSX" },
  png:  { color: "#8B5CF6", bg: "rgba(139,92,246,0.12)", label: "IMG" },
  jpg:  { color: "#8B5CF6", bg: "rgba(139,92,246,0.12)", label: "IMG" },
  jpeg: { color: "#8B5CF6", bg: "rgba(139,92,246,0.12)", label: "IMG" },
  webp: { color: "#8B5CF6", bg: "rgba(139,92,246,0.12)", label: "IMG" },
  default: { color: "#9CA3AF", bg: "rgba(156,163,175,0.10)", label: "FILE" },
};
export function fileTypeMeta(filename = "") {
  const m = filename.toLowerCase().match(/\.([a-z0-9]+)$/);
  const ext = m ? m[1] : "";
  return FILE_TYPE_META[ext] || FILE_TYPE_META.default;
}
export function FileActionChip({ filename, url, onView, onDownload, testid, onDelete = null, sizeLabel = null, compact = false }) {
  const meta = fileTypeMeta(filename);
  // Spec rev137 (2026-02-06) — retrait du bouton « Imprimer » : son
  // action était identique à « Voir » (ouverture nouvel onglet + Ctrl+P
  // manuel), donc redondante. Seuls Voir et Télécharger sont conservés.
  return (
    <div
      className="inline-flex items-center gap-2 rounded-lg pl-2 pr-1 py-1"
      style={{
        background: compact ? "rgba(255,255,255,0.04)" : "rgba(255,255,255,0.03)",
        border: compact ? "0.5px solid rgba(255,255,255,0.08)" : "1px solid rgba(255,255,255,0.07)",
        borderRadius: compact ? 7 : undefined,
        padding: compact ? "6px 4px 6px 10px" : undefined,
        maxWidth: "100%",
      }}
      data-testid={testid}
    >
      <div
        className="flex items-center justify-center rounded-md shrink-0 font-bold"
        style={{
          width: compact ? "auto" : 30, height: compact ? 18 : 30, fontSize: 9, fontWeight: 600, padding: compact ? "0 6px" : 0, borderRadius: compact ? 4 : undefined,
          background: meta.bg, color: meta.color,
          border: `1px solid ${meta.color}33`, letterSpacing: "0.02em",
        }}
        title={meta.label}
      >
        {meta.label}
      </div>
      <span
        className="font-medium truncate min-w-0"
        style={{ color: compact ? "#ececf0" : "#EDEDED", maxWidth: 220, fontSize: compact ? 11.5 : 12 }}
        title={filename}
      >
        {filename}
      </span>
      {sizeLabel && <span style={{ fontSize: 10, color: "#71717c", flexShrink: 0 }}>{sizeLabel}</span>}
      <span aria-hidden="true" style={{ width: 1, height: 16, background: "rgba(255,255,255,.1)", margin: "0 4px", flexShrink: 0 }} />
      <button
        type="button" onClick={onView}
        className="w-7 h-7 rounded-md inline-flex items-center justify-center transition-colors hover:bg-white/10"
        title="Voir" data-testid={`${testid}-view`}
        style={{ color: "#9CA3AF" }}
      >
        <Eye size={13} strokeWidth={2.2} />
      </button>
      <button
        type="button" onClick={onDownload}
        className="w-7 h-7 rounded-md inline-flex items-center justify-center transition-colors hover:bg-white/10"
        title="Télécharger" data-testid={`${testid}-download`}
        style={{ color: "#9CA3AF" }}
      >
        <Download size={13} strokeWidth={2.2} />
      </button>
      {onDelete && (
        <button
          type="button" onClick={onDelete}
          className="w-7 h-7 rounded-md inline-flex items-center justify-center transition-colors hover:bg-red-500/15"
          title="Supprimer" data-testid={`${testid}-delete`}
          style={{ color: "#F87171" }}
        >
          <Trash2 size={12} strokeWidth={2.2} />
        </button>
      )}
    </div>
  );
}

